import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useEffect, useMemo, useState, } from 'react';
import { applyColorMode, getStoredColorMode, } from './applyTheme.js';
const ColorModeContext = createContext(null);
export function ColorModeProvider({ theme, children }) {
    const [mode, setModeState] = useState(() => getStoredColorMode());
    useEffect(() => {
        applyColorMode(mode, { theme, persist: true });
    }, [mode, theme]);
    const setMode = useCallback((next) => {
        setModeState(next);
    }, []);
    const toggle = useCallback(() => {
        setModeState((current) => (current === 'light' ? 'dark' : 'light'));
    }, []);
    const value = useMemo(() => ({ mode, setMode, toggle }), [mode, setMode, toggle]);
    return _jsx(ColorModeContext.Provider, { value: value, children: children });
}
export function useColorMode() {
    const context = useContext(ColorModeContext);
    if (!context) {
        throw new Error('useColorMode must be used within ColorModeProvider');
    }
    return context;
}
//# sourceMappingURL=ColorModeProvider.js.map